import Axios from "@/plugins/axios";

class PlanningApi {
  getPlannings(
    ofObjId,
    userAccountObjId,
    startDate,
    endDate,
    interviewManagerObjId
  ) {
    let url = `api/planning/${ofObjId}/${userAccountObjId}/planning/getList`;
    url += `?startDate=${startDate}&endDate=${endDate}`;

    if (interviewManagerObjId) {
      url += `&interviewManagerObjId=${interviewManagerObjId}`;
    }
    return Axios.get(url);
  }

  createPlanning(ofObjId, userAccountObjId, planningData) {
    return Axios.post(
      `api/planning/${ofObjId}/${userAccountObjId}/planning/create`,
      planningData
    );
  }

  deletePlanning(ofObjId, userAccountObjId, planningId) {
    return Axios.delete(
      `api/planning/${ofObjId}/${userAccountObjId}/${planningId}/planning/delete`
    );
  }

  updatePlanning(ofObjId, userAccountObjId, planningId, planningData) {
    return Axios.patch(
      `api/planning/${ofObjId}/${userAccountObjId}/${planningId}/planning/update`,
      planningData
    );
  }

  searchCandidacies(ofObjId, userAccountObjId, searchTerm) {
    return Axios.post(
      `api/planning/${ofObjId}/${userAccountObjId}/candidacy/search`,
      { search: searchTerm }
    );
  }

  searchInterviewManagers(ofObjId, userAccountObjId, searchTerm) {
    return Axios.post(
      `api/planning/${ofObjId}/${userAccountObjId}/interviewManager/search`,
      { search: searchTerm }
    );
  }

  getMeetings(ofObjId, userAccountObjId, planningId) {
    return Axios.get(
      `api/planning/${ofObjId}/${userAccountObjId}/${planningId}/meeting/getList`
    );
  }

  getPublicMeetingsByCandidacy() {
    return Axios.get(`/api/candidacy/meeting/public/getList`);
  }

  getBookedPublicMeeting() {
    return Axios.get(`/api/candidacy/meeting/public/getBooked`);
  }

  assignPublicMeeting(meetingId) {
    return Axios.patch(`/api/candidacy/meeting/public/${meetingId}/assign`);
  }

  updateMeeting(ofObjId, userAccountObjId, meetingId, meetingData) {
    return Axios.patch(
      `api/planning/${ofObjId}/${userAccountObjId}/${meetingId}/meeting/update`,
      meetingData
    );
  }

  getCandidacyDetails(ofObjId, userAccountObjId, meetingId) {
    return Axios.get(
      `api/planning/${ofObjId}/${userAccountObjId}/candidacy/${meetingId}`
    );
  }

  getMeetingDetails(ofObjId, userAccountObjId, meetingId) {
    return Axios.get(
      `planning/${ofObjId}/${userAccountObjId}/meeting/${meetingId}`
    );
  }

  login(email, password) {
    return Axios.post(`api/planning/auth/login`, {
      email,
      password,
    });
  }

  getAzureAuthUrl(returnTo) {
    return Axios.get("api/planning/auth/azure/url", { params: { returnTo }, withCredentials: true });
  }

  resolveCandidacyPlanning(userAccountObjId, candidatContactObjId) {
    return Axios.get(`api/planning/${userAccountObjId}/candidatures/${candidatContactObjId}/destination`);
  }

  logout(userAccountObjId) {
    return Axios.post(`api/planning/auth/logout`, { userAccountObjId });
  }

  getConvocationPreview(ofObjId, userAccountObjId, meetingId) {
    return Axios.get(
      `api/planning/${ofObjId}/${userAccountObjId}/meeting/${meetingId}/convocation/mail/preview`
    );
  }

  createMeetingForm(ofObjId, userAccountObjId, meetingId) {
    return Axios.post(
      `api/planning/${ofObjId}/${userAccountObjId}/meeting-form/${meetingId}`
    );
  }

  updateMeetingForm(ofObjId, userAccountObjId, meetingId, formData) {
    return Axios.patch(
      `api/planning/${ofObjId}/${userAccountObjId}/meeting-form/${meetingId}`,
      formData
    );
  }

  exportMeetingFormToEva(ofObjId, userAccountObjId, meetingId, file = null) {
    const url = `api/planning/${ofObjId}/${userAccountObjId}/meeting-form/export/${meetingId}`;

    if (file != null) {
      const formData = new FormData();
      if (typeof file?.name === "string" && file.name.trim() !== "") {
        formData.append("file", file, file.name);
      } else {
        formData.append("file", file);
      }
      return Axios.post(url, formData);
    }

    return Axios.post(url);
  }

  getMeetingFormPreviewPdf(ofObjId, userAccountObjId, meetingId) {
    return Axios.get(
      `api/planning/${ofObjId}/${userAccountObjId}/meeting-form/preview/${meetingId}`,
      {
        responseType: "blob",
      }
    );
  }

  getOfList(ofObjId, userAccountObjId) {
    return Axios.get(`api/planning/${ofObjId}/${userAccountObjId}/of-list`);
  }

  getIndex(userAccountObjId, ofObjIdFallBack) {
    return Axios.get(
      `api/planning/${userAccountObjId}/planning/index?ofObjIdFallBack=${ofObjIdFallBack}`
    );
  }

  getAvisOf(ofObjId, userAccountObjId, meetingId) {
    return Axios.get(
      `api/planning/${ofObjId}/${userAccountObjId}/${meetingId}/meeting/avisOf`
    );
  }

  submitAvisOf(
    ofObjId,
    userAccountObjId,
    meetingId,
    { avis, commentEmployeur, commentCandidat, situationEmt }
  ) {
    return Axios.post(
      `api/planning/${ofObjId}/${userAccountObjId}/${meetingId}/meeting/avisOf`,
      { avis, commentEmployeur, commentCandidat, situationEmt }
    );
  }
}

export default new PlanningApi();
